import { Outlet, Link } from "react-router-dom";

import RoleSelector from "../../components/RoleSelector/RoleSelector"

import styles from "./Layout.module.css";
import logo from "./logo/wamsi_logo.jpg";

const Layout = () => {
    return (
        <div className={styles.layout}>
            <RoleSelector />
            <header className={styles.header} role={"banner"}>
                <div className={styles.headerContainer}>
                    <Link to="/" className={styles.headerTitleContainer}>
                        <img height="80px" src={logo} alt="logo"></img>
                        <h3 className={styles.headerTitle}></h3>
                    </Link>
                    <nav>
                    </nav>
                    <h4 className={styles.headerRightText}>Chat On Your Data</h4>
                </div>
            </header>

            <Outlet />
        </div>
    );
};

export default Layout;
